// Package Imports
import { toJS } from "mobx";

// Project Imports
import OptimizationStore from "modules/optimization/store/OptimizationStore";

const generateToggleHighRiskDataStructure = async (reqObj) => {
  let productListData = toJS(OptimizationStore.product_list_data);
  // Show high risk
  if (reqObj.high_risk_flag) {
    productListData.forEach((outerObj) =>
      outerObj.data.forEach(
        (innerObj) =>
          Array.isArray(innerObj.BI) &&
          innerObj.BI.forEach((riskObj) => {
            if (!innerObj.BI.some((item) => item.risk === "high")) {
              innerObj.BI.splice(0, 0, {
                risk: "high",
                BI: {},
                bi_request: {},
                update_BI: false,
              });
            }
          })
      )
    );
  } else {
    // Hide high risk
    productListData.forEach((outerObj) =>
      outerObj.data.forEach(
        (innerObj) =>
          Array.isArray(innerObj.BI) &&
          innerObj.BI.forEach((riskObj) => {
            if (riskObj.risk === "high") {
              innerObj.BI.splice(
                innerObj.BI.findIndex((a) => a.risk === "high"),
                1
              );
            }
            innerObj.selectedRisk = "medium";
            innerObj.selected_risk_type = "medium";
          })
      )
    );
  }

  OptimizationStore.product_list_data = [...productListData];
};

export default generateToggleHighRiskDataStructure;
